export const CountryCodes: Record<string, string> = {
  Andorra: 'AD',
  'United Arab Emirates': 'AE',
  Afghanistan: 'AF',
  'Antigua and Barbuda': 'AG',
  Anguilla: 'AI',
  Albania: 'AL',
  Armenia: 'AM',
  Angola: 'AO',
  Antarctica: 'AQ',
  Argentina: 'AR',
  'American Samoa': 'AS',
  Austria: 'AT',
  Australia: 'AU',
  Aruba: 'AW',
  'Alland Islands': 'AX',
  Azerbaijan: 'AZ',
  'Bosnia and Herzegovina': 'BA',
  Barbados: 'BB',
  Bangladesh: 'BD',
  Belgium: 'BE',
  'Burkina Faso': 'BF',
  'Burkina-Faso': 'BF',
  Bulgaria: 'BG',
  Bahrain: 'BH',
  Burundi: 'BI',
  Benin: 'BJ',
  'Saint Barthelemy': 'BL',
  'Saint-Barth?lemy': 'BL',
  Bermuda: 'BM',
  'Brunei Darussalam': 'BN',
  Brunei: 'BN',
  Bolivia: 'BO',
  Brazil: 'BR',
  Bahamas: 'BS',
  Bhutan: 'BT',
  'Bouvet Island': 'BV',
  Botswana: 'BW',
  Belarus: 'BY',
  Belize: 'BZ',
  Canada: 'CA',
  'Cocos (Keeling) Islands': 'CC',
  'Territory of Cocos (Keeling) Islands': 'CC',
  'Congo, Democratic Republic of the': 'CD',
  'Central African Republic': 'CF',
  'Congo, Republic of the': 'CG',
  Switzerland: 'CH',
  "Cote d'Ivoire": 'CI',
  "Сote d'Ivoire": 'CI',
  'Cook Islands': 'CK',
  Chile: 'CL',
  Cameroon: 'CM',
  China: 'CN',
  Colombia: 'CO',
  'Costa Rica': 'CR',
  Cuba: 'CU',
  'Cape Verde': 'CV',
  'Cape-Verde': 'CV',
  Curacao: 'CW',
  'Christmas Island': 'CX',
  Cyprus: 'CY',
  'Czech Republic': 'CZ',
  Germany: 'DE',
  Djibouti: 'DJ',
  Denmark: 'DK',
  Dominica: 'DM',
  'Dominican Republic': 'DO',
  Algeria: 'DZ',
  Ecuador: 'EC',
  Estonia: 'EE',
  Egypt: 'EG',
  'Western Sahara': 'EH',
  Eritrea: 'ER',
  Spain: 'ES',
  Ethiopia: 'ET',
  Finland: 'FI',
  Fiji: 'FJ',
  'Falkland Islands (Malvinas)': 'FK',
  'Falkland Islands': 'FK',
  'Micronesia, Federated States of': 'FM',
  'Federated States of Micronesia': 'FM',
  'Faroe Islands': 'FO',
  France: 'FR',
  Gabon: 'GA',
  'United Kingdom': 'GB',
  Grenada: 'GD',
  Georgia: 'GE',
  'French Guiana': 'GF',
  Guernsey: 'GG',
  Ghana: 'GH',
  Gibraltar: 'GI',
  Greenland: 'GL',
  Gambia: 'GM',
  Guinea: 'GN',
  Guadeloupe: 'GP',
  'Equatorial Guinea': 'GQ',
  Greece: 'GR',
  'South Georgia and the South Sandwich Islands': 'GS',
  Guatemala: 'GT',
  Guam: 'GU',
  'Guinea-Bissau': 'GW',
  Guyana: 'GY',
  'Hong Kong': 'HK',
  'Heard Island and McDonald Islands': 'HM',
  Honduras: 'HN',
  Croatia: 'HR',
  Haiti: 'HT',
  Hungary: 'HU',
  Indonesia: 'ID',
  Ireland: 'IE',
  Israel: 'IL',
  'Isle of Man': 'IM',
  India: 'IN',
  'British Indian Ocean Territory': 'IO',
  Iraq: 'IQ',
  'Iran, Islamic Republic of': 'IR',
  Iran: 'IR',
  Iceland: 'IS',
  Italy: 'IT',
  Jersey: 'JE',
  Jamaica: 'JM',
  Jordan: 'JO',
  Japan: 'JP',
  Kenya: 'KE',
  Kyrgyzstan: 'KG',
  'Kyrgyz Rep.': 'KG',
  Cambodia: 'KH',
  Kiribati: 'KI',
  Comoros: 'KM',
  'Saint Kitts and Nevis': 'KN',
  'St. Kitts and Nevis': 'KN',
  "Korea, Democratic People's Republic of": 'KP',
  "Democratic People's Republic of Korea": 'KP',
  'Korea, Republic of': 'KR',
  Korea: 'KR',
  Kuwait: 'KW',
  'Cayman Islands': 'KY',
  Kazakhstan: 'KZ',
  Kazakstan: 'KZ',
  "Lao People's Democratic Republic": 'LA',
  Lebanon: 'LB',
  'Saint Lucia': 'LC',
  'St. Lucia': 'LC',
  Liechtenstein: 'LI',
  'Sri Lanka': 'LK',
  Liberia: 'LR',
  Lesotho: 'LS',
  Lithuania: 'LT',
  Luxembourg: 'LU',
  Luxemburg: 'LU',
  Latvia: 'LV',
  Libya: 'LY',
  Morocco: 'MA',
  Monaco: 'MC',
  'Moldova, Republic of': 'MD',
  Moldova: 'MD',
  Montenegro: 'ME',
  'Saint Martin (French part)': 'MF',
  'Saint-Martin(FrenchPart)': 'MF',
  Madagascar: 'MG',
  'Marshall Islands': 'MH',
  'Macedonia, the Former Yugoslav Republic of': 'MK',
  Macedonia: 'MK',
  Mali: 'ML',
  Myanmar: 'MM',
  Mongolia: 'MN',
  Macao: 'MO',
  'Northern Mariana Islands': 'MP',
  Martinique: 'MQ',
  Mauritania: 'MR',
  Montserrat: 'MS',
  Malta: 'MT',
  Mauritius: 'MU',
  Maldives: 'MV',
  Malawi: 'MW',
  Mexico: 'MX',
  Malaysia: 'MY',
  Mozambique: 'MZ',
  Namibia: 'NA',
  'New Caledonia': 'NC',
  Niger: 'NE',
  'Norfolk Island': 'NF',
  Nigeria: 'NG',
  Nicaragua: 'NI',
  Netherlands: 'NL',
  Norway: 'NO',
  Nepal: 'NP',
  Nauru: 'NR',
  Niue: 'NU',
  'New Zealand': 'NZ',
  Oman: 'OM',
  Panama: 'PA',
  Peru: 'PE',
  'French Polynesia': 'PF',
  'Papua New Guinea': 'PG',
  Philippines: 'PH',
  Pakistan: 'PK',
  Poland: 'PL',
  'Saint Pierre and Miquelon': 'PM',
  'Saint-Pierreand Miquelon': 'PM',
  Pitcairn: 'PN',
  'Puerto Rico': 'PR',
  'Palestine, State of': 'PS',
  Portugal: 'PT',
  Palau: 'PW',
  Paraguay: 'PY',
  Qatar: 'QA',
  Reunion: 'RE',
  Romania: 'RO',
  Serbia: 'RS',
  'Russian Federation': 'RU',
  Russia: 'RU',
  Rwanda: 'RW',
  'Saudi Arabia': 'SA',
  'Solomon Islands': 'SB',
  Seychelles: 'SC',
  Sudan: 'SD',
  Sweden: 'SE',
  Singapore: 'SG',
  'Saint Helena': 'SH',
  'Saint Helena Island': 'SH',
  Slovenia: 'SI',
  'Svalbard and Jan Mayen': 'SJ',
  Slovakia: 'SK',
  'Sierra Leone': 'SL',
  'San Marino': 'SM',
  'San-Marino': 'SM',
  Senegal: 'SN',
  Somalia: 'SO',
  Suriname: 'SR',
  'South Sudan': 'SS',
  'Sao Tome and Principe': 'ST',
  'Sao-Tome and Principe': 'ST',
  'El Salvador': 'SV',
  'Republic of El Salvador': 'SV',
  'Sint Maarten (Dutch part)': 'SX',
  'Syrian Arab Republic': 'SY',
  Syria: 'SY',
  Swaziland: 'SZ',
  'Turks and Caicos Islands': 'TC',
  'Turks and Caicos': 'TC',
  Chad: 'TD',
  'French Southern Territories': 'TF',
  Togo: 'TG',
  Thailand: 'TH',
  Tajikistan: 'TJ',
  Tokelau: 'TK',
  'Timor-Leste': 'TL',
  Turkmenistan: 'TM',
  Tunisia: 'TN',
  Tonga: 'TO',
  Turkey: 'TR',
  'Trinidad and Tobago': 'TT',
  Tuvalu: 'TV',
  'Taiwan, Province of China': 'TW',
  Taiwan: 'TW',
  'United Republic of Tanzania': 'TZ',
  Ukraine: 'UA',
  Uganda: 'UG',
  'United States': 'US',
  'U.S.A.': 'US',
  Uruguay: 'UY',
  Uzbekistan: 'UZ',
  'Holy See (Vatican City State)': 'VA',
  'Saint Vincent and the Grenadines': 'VC',
  'St. Vincent and the Grenadines': 'VC',
  Venezuela: 'VE',
  'British Virgin Islands': 'VG',
  'Virgin Islands, UK': 'VG',
  'Virgin Islands,British': 'VG',
  'US Virgin Islands': 'VI',
  'Virgin Islands, USA': 'VI',
  Vietnam: 'VN',
  Vanuatu: 'VU',
  'Wallis and Futuna': 'WF',
  Samoa: 'WS',
  Kosovo: 'XK',
  Yemen: 'YE',
  Mayotte: 'YT',
  'South Africa': 'ZA',
  Zambia: 'ZM',
  Zimbabwe: 'ZW',
};
